import './Dropdown.scss';
import { defineComponent, h, PropType } from 'vue';

type Cursor =
    'pointer'
    | 'help';

export default defineComponent({
    props: {
        title: { required: true, type: String },
        cursor: { required: false, type: String as PropType<Cursor>, default: 'pointer' },
    },

    data() {
        return {
            shown: false,
            shown_once: false,
        };
    },

    watch: {
        shown(value: typeof this.shown) {
            if (value)
                this.shown_once = true;
        },
    },

    render() {
        return h('div', {
            class: 'dropdown'
        }, [
            h('header', {
                class: { shown: this.shown },
                onClick: () => this.shown = !this.shown,
                style: {
                    cursor: this.cursor,
                },
            }, [
                this.title,
                h('span', { class: 'arrow' }),
            ]),

            this.$slots.default && this.shown_once
                ? h('div', {
                    class: { body: true, hidden: !this.shown },
                }, this.$slots.default())
                : '',
        ]);
    },
});
